import { createSlice } from '@reduxjs/toolkit';
import HbsCihaztanimDTO from 'src/models/RadyolojiModul/HbsCihaztanimDTO';
import MapReducerPayloads from 'src/models/store/MapReducerPayloads';

// 1
interface RadyolojiCihazTanimState {
  cihazEkleDialogOpen: boolean;
  editCihazValues: HbsCihaztanimDTO;
  cihazData: Array<HbsCihaztanimDTO>;
  refetchTrigger: boolean;
}

// 2
const initialState: RadyolojiCihazTanimState = {
  cihazEkleDialogOpen: false,
  editCihazValues: null,
  cihazData: [],
  refetchTrigger: false
}

// 3
const RadyolojiCihazTanimReducers = {
  setCihazEkleDialogOpen: (state: RadyolojiCihazTanimState, action) => {
    state.cihazEkleDialogOpen = action.payload;
  },

  setEditCihazValues: (state: RadyolojiCihazTanimState, action) => {
    state.editCihazValues = action.payload;
  },

  setCihazData: (state: RadyolojiCihazTanimState, action) => {
    state.cihazData = action.payload;
  },

  setRefetchTrigger: (state: RadyolojiCihazTanimState, action) => {
    state.refetchTrigger = action.payload;
  },
}

const RadyolojiCihazTanimSlice = createSlice<RadyolojiCihazTanimState, MapReducerPayloads<RadyolojiCihazTanimState, {
  // 4
  setCihazEkleDialogOpen: boolean,
  setEditCihazValues: HbsCihaztanimDTO,
  setCihazData: Array<HbsCihaztanimDTO>,
  setRefetchTrigger: boolean
}>>({
  name: 'radyolojiCihazTanim',
  initialState,
  reducers: RadyolojiCihazTanimReducers,
})

export default RadyolojiCihazTanimSlice;
